import { useContext } from 'react';
import { ConfirmContext, type ConfirmApi } from './ConfirmProvider';

/** Access the shared confirm/alert dialog service.  Must be inside <ConfirmProvider>. */
export function useConfirm(): ConfirmApi {
  const ctx = useContext(ConfirmContext);
  if (!ctx) throw new Error('useConfirm must be used within <ConfirmProvider> (mounted in main.tsx).');
  return ctx;
}
